import { useGetList } from "ra-core";

interface OnboardingStatus {
  needsOnboarding: boolean;
  isPending: boolean;
  orgCount: number;
}

/**
 * Checks if the current user has a configured organization.
 *
 * If the organizations table has zero rows visible to this user (via RLS),
 * the user needs to go through BldrOS onboarding.
 *
 * NOTE: This hook queries the "organizations" resource. If that resource
 * doesn't exist yet in Supabase (Phase 1a not applied), it will return
 * needsOnboarding: false to avoid blocking the dashboard.
 */
export function useOnboardingStatus(): OnboardingStatus {
  const { total, isPending, error } = useGetList("organizations", {
    pagination: { page: 1, perPage: 1 },
  });

  // If the organizations table doesn't exist yet or RLS blocks access,
  // don't block the dashboard — skip onboarding for now
  if (error) {
    return { needsOnboarding: false, isPending: false, orgCount: 0 };
  }

  return {
    needsOnboarding: !isPending && (total === 0 || total === undefined),
    isPending,
    orgCount: total ?? 0,
  };
}
